import { z } from 'zod'
import { Model } from './architecture'

export const PhoneValidation = z.object({
  value: z
    .string({ required_error: '[Phone] value is required' })
    .regex(/^\+?\d{10,15}$/, { message: '[Phone] Invalid value' }),
})

export class Phone extends Model {
  static create({ value }: { value: string }) {
    PhoneValidation.parse({ value })
    return new Phone(value)
  }

  static createOrUndefined({ value }: { value?: string | undefined }) {
    if (!value) return undefined
    PhoneValidation.parse({ value })
    return new Phone(value)
  }

  constructor(private readonly _value: string) {
    super()
  }

  get value() { return this._value } // prettier-ignore

  toJSON() {
    return { value: this.value }
  }
}
